<template>
  <div :class="[containerClasses({ size: props.size }), 'EdroneAiSparklesIcon__animation']">
    <svg
      v-for="n in 3"
      :key="`sparkle-${n}`"
      class="tw:opacity-50 tw:absolute"
      :class="[iconClasses({ variant: props.variant }), `EdroneAiSparklesIcon__${props.size}--icon-${n}`]"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path :d="svgPath" />
    </svg>
  </div>
</template>

<script setup lang="ts">
import { cva } from "class-variance-authority";

interface Props {
  variant?: "light" | "dark";
  size?: "small" | "medium" | "large";
}

const props = withDefaults(defineProps<Props>(), {
  variant: "dark",
  size: "medium",
});

const svgPath =
  "M6.45815 0.292837C6.37628 0.113356 6.1968 0 6.00157 0C5.80635 0 5.62687 0.113356 5.545 0.292837L3.88245 3.88245L0.292837 5.54185C0.113356 5.62372 0 5.8032 0 6.00157C0 6.19995 0.113356 6.37628 0.292837 6.45815L3.88559 8.11755L5.54185 11.7072C5.62372 11.8866 5.8032 12 5.99843 12C6.19365 12 6.37313 11.8866 6.455 11.7072L8.11441 8.11441L11.7072 6.455C11.8866 6.37313 12 6.19365 12 5.99843C12 5.8032 11.8866 5.62372 11.7072 5.54185L8.11755 3.88559L6.45815 0.292837Z";

const containerClasses = cva("tw:relative", {
  variants: {
    size: {
      small: "tw:relative tw:w-3 tw:h-3",
      medium: "tw:relative tw:w-5 tw:h-5",
      large: "tw:relative tw:w-8 tw:h-8",
    },
  },
});

const iconClasses = cva("tw:opacity-50 tw:absolute", {
  variants: {
    variant: {
      light: "tw:fill-white",
      dark: "tw:fill-violet-500",
    },
  },
});
</script>

<style scoped>
.EdroneAiSparklesIcon__animation > * {
  animation-name: sparkle-animation;
  animation-duration: 2.6s;
  animation-iteration-count: infinite;
  animation-timing-function: ease;
  animation-play-state: running;
}

.EdroneAiSparklesIcon__small--icon-1 {
  top: 2.9px;
  left: 1.2px;
  width: 6px;
  height: 6px;
  animation-delay: 1.2s;
}

.EdroneAiSparklesIcon__small--icon-2 {
  top: 1.2px;
  left: 7.2px;
  width: 3.6px;
  height: 3.6px;
  animation-delay: 0.6s;
}

.EdroneAiSparklesIcon__small--icon-3 {
  bottom: 1.2px;
  left: 7.2px;
  width: 3.6px;
  height: 3.6px;
  animation-delay: 0s;
}
.EdroneAiSparklesIcon__medium--icon-1 {
  top: 5px;
  left: 2px;
  width: 10px;
  height: 10px;
  animation-delay: 1.2s;
}

.EdroneAiSparklesIcon__medium--icon-2 {
  top: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  animation-delay: 0.6s;
}

.EdroneAiSparklesIcon__medium--icon-3 {
  bottom: 2px;
  right: 2px;
  width: 6px;
  height: 6px;
  animation-delay: 0s;
}
.EdroneAiSparklesIcon__large--icon-1 {
  top: 7.7px;
  left: 3.2px;
  width: 16px;
  height: 16px;
  animation-delay: 1.2s;
}

.EdroneAiSparklesIcon__large--icon-2 {
  top: 3.2px;
  right: 3.2px;
  width: 9.6px;
  height: 9.6px;
  animation-delay: 0.6s;
}

.EdroneAiSparklesIcon__large--icon-3 {
  bottom: 3.2px;
  right: 3.2px;
  width: 9.6px;
  height: 9.6px;
  animation-delay: 0s;
}

@keyframes sparkle-animation {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  20% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
}
</style>
